import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-mist border-y border-mist-dark" data-id="element-248" data-mp="3sq1vbv6hrw06">
      <div className="max-w-7xl mx-auto px-4" data-id="element-249" data-mp="3ssem8xu89gpd">
        <div className="text-center mb-7" data-id="element-250" data-mp="3nz21wzwkzw2f">
          <p className="text-navy font-bold tracking-widest uppercase text-sm" data-id="element-251" data-mp="3nyafofovjaot">
            ⭐ What Track &amp; Field Coaches Are Saying
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-252" data-mp="nat5dvg60ef">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.initials} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-mist-dark p-6 rounded-2xl relative shadow-sm flex flex-col" data-id="element-253" data-mp="figydympxv6p" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-254" data-mp="cek479c1cziy">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-255" data-mp="lcvqx09s7d64" data-mpi={starIndex} />)}
              </div>
              <p className="text-slate italic mb-6 text-sm leading-relaxed" data-id="element-256" data-mp="q4ds9pfpvfrm">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-257" data-mp="v2p2i19xbsad">
                <div className="w-10 h-10 rounded-full bg-azure-light border border-azure flex items-center justify-center text-azure-dark font-bold text-xs shrink-0" data-id="element-258" data-mp="101s5zha99qg8">
                  {testimonial.initials}
                </div>
                <div data-id="element-259" data-mp="191oo10253r2b">
                  <div className="font-bold text-navy text-sm" data-id="element-260" data-mp="190vrerwwahxw">{testimonial.name}</div>
                  <div className="text-xs text-azure" data-id="element-261" data-mp="35x2z3m00foqk">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}